// @flow
import axios from 'axios'
import mapKeys from 'lodash/mapKeys'
import { push } from 'react-router-redux'
import {
  FETCH_PROPERTY_REQUEST,
  FETCH_PROPERTY_SUCCESS,
  FETCH_PROPERTY_FAILURE,
  FETCH_PROPERTIES_REQUEST,
  FETCH_PROPERTIES_SUCCESS,
  FETCH_PROPERTIES_FAILURE,
  FETCH_WALKSCORE_SUCCESS,
  FETCH_OPEN_HOUSES_REQUEST,
  FETCH_OPEN_HOUSES_SUCCESS,
  FETCH_OPEN_HOUSES_FAILURE
} from '../constants'

function getSearchParamsFromOptions(options) {
  const params = {}
  mapKeys(options, (value, key) => {
    if (value) {
      params[key] = value
    }
  })
  return params
}

export function fetchProperties(options: Object) {
  return (dispatch: Function) => {
    dispatch({ type: FETCH_PROPERTIES_REQUEST })
    const params = getSearchParamsFromOptions(options)
    return axios
      .get('/properties', { params })
      .then((response) => {
        dispatch({
          type: FETCH_PROPERTIES_SUCCESS,
          properties: response.data,
          results: response.meta.results
        })
      })
      .catch(() => {
        dispatch({ type: FETCH_PROPERTIES_FAILURE })
      })
  }
}

export function fetchOpenHouses(options: Object) {
  return (dispatch: Function) => {
    dispatch({ type: FETCH_OPEN_HOUSES_REQUEST })
    const params = getSearchParamsFromOptions(options)
    return axios
      .get('/open_houses', { params })
      .then((response) => {
        dispatch({
          type: FETCH_OPEN_HOUSES_SUCCESS,
          properties: response.data,
          results: response.meta.results
        })
      })
      .catch(() => {
        dispatch({ type: FETCH_OPEN_HOUSES_FAILURE })
      })
  }
}

export function fetchProperty(mlsId: number) {
  return (dispatch: Function) => {
    dispatch({ type: FETCH_PROPERTY_REQUEST })
    axios
      .get(`/properties/${mlsId}`)
      .then((response) => {
        dispatch({ type: FETCH_PROPERTY_SUCCESS, property: response.data })
      })
      .catch(() => {
        dispatch(push('/properties'))
        dispatch({ type: FETCH_PROPERTY_FAILURE })
      })
  }
}

export function fetchWalkscore(lat: number, lng: number, address: string) {
  return (dispatch: Function) =>
    axios
      .get('/properties/walkscore', { params: { lat, lng, address } })
      .then((response) => {
        dispatch({ type: FETCH_WALKSCORE_SUCCESS, walkscore: response.data })
      })
}



// WEBPACK FOOTER //
// ./src/actions/properties.js